import { ShipDataType } from "@/types/apiTypes";
import { getToken } from "@/utils/authHelpers";
import axios from "axios";
import { API_BASE_URL } from "@/utils/api";

export const removeShipFromProjectApi = async (
  ship: ShipDataType,
  selectedProjectId: string | null,
): Promise<void> => {
  if (!selectedProjectId) {
    throw new Error("No project selected");
  }

  const token = await getToken();
  if (!token) {
    throw new Error("Authorization token is required");
  }

  try {
    await axios.delete(
      `${API_BASE_URL}/projects/${selectedProjectId}/ships/${ship.id}`,
      { headers: { Authorization: `Bearer ${token}` } },
    );
  } catch (error) {
    console.error("Failed to remove ship from project", error);
    throw new Error("Failed to remove ship");
  }
};
